import { render, staticRenderFns } from "./TextRowsStyle.vue?vue&type=template&id=a594f3f0&scoped=true"
import script from "./TextRowsStyle.vue?vue&type=script&lang=js"
export * from "./TextRowsStyle.vue?vue&type=script&lang=js"
import style0 from "./TextRowsStyle.vue?vue&type=style&index=0&id=a594f3f0&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../frontAgencies/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a594f3f0",
  null
  
)

export default component.exports